import { HeaderContainer } from "../../components/Layout/HeaderContainer/HeaderContainer";
import { PageContainer } from "../../components/Layout/PageContainer/PageContainer";

import { StorageContent } from "../../components/Pages/Storage/Main/StorageContent/StorageContent";
import { AccessHeaderLogo } from "../../components/Shared/Buttons/AccessHeaderLogo";
import { MenuButton } from "../../components/Shared/Buttons/MenuButton";
import { PageTitle } from "../../components/Shared/Headings/PageTitle";

export function StoragePage() {
  return (
    <PageContainer
      header={{
        content: (
          <HeaderContainer
            start={<MenuButton />}
            middle={<PageTitle title="Storage" />}
            end={<AccessHeaderLogo />}
          />
        )
      }}
      main={{
        content: <StorageContent />
      }}
    />
  );
}
